import { render, staticRenderFns } from "./xhLeaves.vue?vue&type=template&id=2fc0d7a2&scoped=true"
import script from "./xhLeaves.vue?vue&type=script&lang=js"
export * from "./xhLeaves.vue?vue&type=script&lang=js"
import style0 from "./xhLeaves.vue?vue&type=style&index=0&id=2fc0d7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0d7a2",
  null
  
)

export default component.exports